import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const directionToDegrees = (direction) => {
  const directions = {
    'N': 0, 'NNE': 22.5, 'NE': 45, 'ENE': 67.5, 'E': 90, 'ESE': 112.5,
    'SE': 135, 'SSE': 157.5, 'S': 180, 'SSW': 202.5, 'SW': 225, 'WSW': 247.5,
    'W': 270, 'WNW': 292.5, 'NW': 315, 'NNW': 337.5
  };
  return directions[direction.toUpperCase()] || 0;
};

export const kphToMph = (kph) => (kph == null || isNaN(kph) ? 0 : kph * 0.621371);

export const formatPhoneNumber = (countryCode, phoneNumber) => {
  const code = typeof countryCode === 'string' && countryCode ? countryCode.replace('+', '') : '';
  const prefix = code ? `+${code}` : '';
  const cleaned = ('' + phoneNumber).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return `${prefix} ${match[1]}-${match[2]}-${match[3]}`.trim();
  }
  return `${prefix} ${phoneNumber}`.trim();
};

export const parseUTC = (utcString) => {
  if (typeof utcString !== 'string' || !utcString) {
    console.error('Invalid utcString:', utcString);
    return null;
  }
  const timestamp = new Date(utcString).getTime();
  if (isNaN(timestamp)) {
    console.error('Unable to parse utcString:', utcString);
    return null;
  }
  return timestamp;
};

export const formatDateTime = (timestamp, timezone) => {
  if (!timestamp || !timezone) return 'N/A';
  const date = new Date(timestamp);
  if (isNaN(date.getTime())) return 'Invalid Date';

  const zonedDate = toZonedTime(date, timezone);
  return format(zonedDate, 'MM/dd/yyyy, HH:mm');
};

export const getTimeRange = (dateRange) => {
  const now = new Date().getTime();
  let start;
  switch (dateRange) {
    case 'last4h': start = now - 4 * 60 * 60 * 1000; break;
    case 'last12h': start = now - 12 * 60 * 60 * 1000; break;
    case 'last24h': start = now - 24 * 60 * 60 * 1000; break;
    case 'last3d': start = now - 3 * 24 * 60 * 60 * 1000; break;
    case 'last7d': start = now - 7 * 24 * 60 * 60 * 1000; break;
    case 'last15m': start = now - 15 * 60 * 1000; break; // 15 minutes
    default: start = now - 24 * 60 * 60 * 1000; // Default to 24 hours
  }
  const range = { start, end: now };
  return range;
};

export const timezones = [
  { label: 'UTC', value: 'UTC' },
  { label: 'Saudi Arabia', value: 'Asia/Riyadh' },
  { label: 'Eastern', value: 'America/New_York' },
  { label: 'Central', value: 'America/Chicago' },
  { label: 'Mountain', value: 'America/Denver' },
  { label: 'Pacific', value: 'America/Los_Angeles' },
  { label: 'Arizona', value: 'America/Phoenix' },
];
